export default __webpack_public_path__ + "static/niche@992-58b2e0318d6c6b4af4645b4b014911a8.webp";